<template>
  <validation-observer v-slot="{ invalid }" slim>
    <form @submit.prevent="handleSubmit">
      <h4 class="mb-4">{{ tag.id ? "Update" : "Create" }} Tag</h4>

      <base-input
        v-model="formData.name"
        rules="required"
        name="Tag"
        label="Tag"
      ></base-input>

      <div class="d-flex justify-content-between">
        <base-button
          @click="() => $emit('form:cancel', true)"
          type="white"
          class="px-0 bg-transparent shadow-none"
          >Cancel</base-button
        >
        <base-button
          :disabled="invalid"
          :loading="formProcessing"
          native-type="submit"
          type="primary"
          size="sm"
          class="py-2 px-3"
          >Save</base-button
        >
      </div>
    </form>
  </validation-observer>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  onUnmounted,
} from "@vue/composition-api";
import { createVuexHelpers } from "vue2-helpers";

export default defineComponent({
  name: "TagsForm",
  emits: ["form:cancel", "form:success"],
  setup(props, { emit }) {
    const { useGetters, useActions, useMutations } = createVuexHelpers();

    const { tag, reports } = useGetters(["tag", "reports"]);
    const { createTag, updateTag } = useActions(["createTag", "updateTag"]);
    const { UPDATE_TAG } = useMutations(["UPDATE_TAG"]);

    const formData = reactive({});

    const formProcessing = ref(false);

    const handleSubmit = async () => {
      formProcessing.value = true;

      if (formData.id) {
        await updateTag(formData);

        if (reports.value.results.length) {
          const reportsList = reports.value.results.filter(
            (item) => !!item.tags.find((tag) => tag.id == formData.id)
          );

          for (const reportItem of reportsList) {
            reportItem.tags = reportItem.tags.map((tag) => {
              if (tag.id == formData.id) tag.name = formData.name;

              return tag;
            });
          }
        }
      } else {
        await createTag(formData.name);
      }

      formProcessing.value = false;

      emit("form:success", true);
    };

    onMounted(() => {
      formData.id = tag.value.id;
      formData.name = tag.value.name;

      Vue.prototype.$bus.trackEvent(
        "error-catched",
        () => (formProcessing.value = false)
      );
    });

    onUnmounted(() => {
      UPDATE_TAG({
        id: 0,
        tag: "",
      });
    });

    return {
      tag,
      formData,
      formProcessing,
      handleSubmit,
    };
  },
});
</script>
